
import React from 'react';
import { ProgressSpinner } from 'primereact/progressspinner';

export default function Loader() {
    return (
        <div className="flex flex-column justify-content-center align-items-center py-6" aria-busy="true" aria-label="Cargando">
            <ProgressSpinner
                strokeWidth={3}
                style={{ width: '70px', height: '70px' }}
                animationDuration=".8s"
            />
            <span className="text-500 font-medium">Cargando información...</span>
        </div>
    );
}        
